import { useEffect, useState, memo } from 'react';
import { Button, Tour } from 'antd';
import './style.scss';
import { useMediaQuery } from 'react-responsive';
import { isEmpty } from 'lodash';
import {
  useUpdateApplicationSettingMutation,
  Guidedtour,
} from './store/GuidedTourSlice';
import { useGetUserProfileQuery } from '../../../app/auth/apiSlice';
import { useGetSideNavMenusQuery } from '../../Admin/Menu/store/menuAdminSlice';
import Icons from '../../../configs/icon.config';

interface GuidedTourProps {
  steps?: any;
}

function GuidedTour({ steps }: GuidedTourProps) {
  const { data: profile, refetch } = useGetUserProfileQuery();
  const { data: menuData } = useGetSideNavMenusQuery();

  const [updateApplicationSetting] = useUpdateApplicationSettingMutation();
  const updatedTourSettings: Guidedtour = {
    guided_tour: 'false', // Update this with the desired value
  };
  // const [open, setOpen] = useState();
  // const guidedTour = profile.settings.guided_tour;

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const currentUrl = window.location.href;
  let noTour = false;
  if (currentUrl.indexOf('/admin') > 0) {
    noTour = true;
  }

  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!isEmpty(menuData)) {
      setOpen(profile?.user_settings?.guided_tour);
    }
  }, [menuData, profile?.user_settings?.guided_tour]);

  const onClose = async () => {
    try {
      await updateApplicationSetting(updatedTourSettings).unwrap();
      refetch();
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, 1000);
    } catch (err) {
      // console.error('Error updating guided tour settings:', err);
    }
  };

  const onSkip = () => {
    onClose();
  };

  return (
    <div>
      {!isMobile && !noTour && (
        <Tour
          // @ts-ignore
          open={open || !!undefined}
          onClose={onClose}
          steps={steps}
          indicatorsRender={(current, total) => (
            <span className="flex items-center justify-center gap-4">
              {current + 1} / {total}
              {current < total - 1 && (
                <Button
                  size="small"
                  onClick={onSkip}
                  style={{
                    marginLeft: '8px',
                  }}
                  className="flex items-center justify-center text-pink-600 dark:text-[#EB3E8E] border-pink-600 dark:border-[#EB3E8E]"
                >
                  {Icons.doubleLeft}
                  <span className="mt-1">Skip</span>
                </Button>
              )}
            </span>
          )}
        />
      )}
    </div>
  );
}

export default memo(GuidedTour);
